import * as types from './mutation-types'

export default {
    [types.BOOTSTRAP_CURRENT_USER] (state, user) {
        state.currentUser = user
    },
    // [types.LOAD_USERS] (state, users) {
    //     state.users = users.data
    // },

    [types.LOAD_USER] (state, user) {
        state.user = user.data
    },

    [types.ADD_USER]: (state, data) => {
        state.users.push(data)
    },

    [types.LOAD_USERS]: (state, data) => {
        data.forEach((user) => {
            let userExist = state.users.find(x => x.id === user.id)
            if(userExist){
                state.users = state.users.map((x) => {
                    if(x.id === user.id){
                        return user
                    }

                    return x
                })
            }else{
                state.users.push(user)
            }
        })

    },

    [types.SET_USER](state, data) {
        state.users = state.users.map((x) => {
            if(x.id === data.id){
                return data
            }

            return x
        })
    },
}